import { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { findLast } from 'lodash/fp'
import { getMetadata } from 'pages/Cms/helper'
import type { CmsContentT, History } from 'types'
import { historyModificationTypes } from 'types'

const useCmsContentView = (content: CmsContentT) => {
  const { language } = useFavurTranslation()
  const metadata = useMemo(() => getMetadata({ content, language }), [content, language])
  const { history, audiences, restrictAbsenceComment, isAbsenceRestricted, contentType } = content
  const createdHistory = useMemo(
    () =>
      history?.find(
        (historyElement: History) => historyElement.modificationType === historyModificationTypes.createContent,
      ),
    [history],
  )
  const updatedHistory = useMemo(
    () =>
      history &&
      findLast(
        (historyElement: History) => historyElement.modificationType === historyModificationTypes.updateContent,
        history,
      ),
    [history],
  )

  return {
    createdHistory,
    updatedHistory,
    metadata,
    audiences,
    restrictAbsenceComment,
    isAbsenceRestricted,
    contentType,
  }
}

export default useCmsContentView
